import axios from "axios";
import { toast } from "react-toastify";
import { Address } from "../@types/subscriptionInfo";

const AddressService = {
    find: async (zipcode: string): Promise<Address> => {
        const token = localStorage.getItem("user-token");

        const config = {
            method: "get",
            maxBodyLength: Infinity,
            url: process.env.REACT_APP_DELEND_API + "/utils/v1/cep/" + zipcode,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        };

        return axios(config)
            .then(function (response) {
                return response.data;
            })
            .catch((error) => {
                toast.error(error.response);
            })
    }
}

export default AddressService;